<div class="app-container" [class.is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="app-toolbar toolbar-dense">
    <div class="app-toolbar-sections">
      <!-- Start: Hamburger + Title -->
      <div class="app-toolbar-start">
        <button mat-icon-button (click)="mainSideNav.toggle()"><mat-icon>menu</mat-icon></button>
        <span class="app-toolbar-title" i18n="@@Cart">Cart</span>
      </div>

      <!-- Center: Search → Filters → Display → Actions -->
      <div class="app-toolbar-center" *ngIf="mode === 'CART'">
        <!-- Search -->
        <div class="toolbar-search">
          <mat-icon>search</mat-icon>
          <input type="text" [(ngModel)]="searchString" i18n-placeholder="@@Search" placeholder="Search">
          <mat-icon *ngIf="searchString" class="toolbar-search-clear" (click)="searchString = ''">close</mat-icon>
        </div>

        <div class="toolbar-divider"></div>

        <!-- Filter Group 1: Item type filters -->
        <div class="toolbar-filters">
          <button class="toolbar-filter" [class.active]="showProducts" (click)="showProducts = !showProducts" i18n-title="@@Books" title="Books">
            <mat-icon>menu_book</mat-icon><span class="toolbar-btn-label" i18n="@@Books">Books</span>
          </button>
          <button class="toolbar-filter" [class.active]="showDrafts" (click)="showDrafts = !showDrafts" i18n-title="@@Drafts" title="Drafts">
            <mat-icon>edit_note</mat-icon><span class="toolbar-btn-label" i18n="@@Drafts">Drafts</span>
          </button>
        </div>
        <!-- Standalone toggles -->
        <button class="toolbar-filter-standalone" [class.active]="!showNonZero" (click)="showNonZero = !showNonZero" i18n-title="@@Show Zero Quantities" title="Show Zero Quantities">
          <mat-icon>{{ showNonZero ? 'filter_list' : 'filter_list_off' }}</mat-icon>
        </button>
        <button class="toolbar-filter-standalone" [class.active]="showOnlyRecent" (click)="showOnlyRecent = !showOnlyRecent" i18n-title="@@Recently Ordered" title="Recently Ordered">
          <mat-icon>{{ showOnlyRecent ? 'history' : 'history_toggle_off' }}</mat-icon>
        </button>

        <div class="toolbar-divider"></div>

        <!-- Filter Group 2: Display options -->
        <div class="toolbar-filters">
          <button class="toolbar-filter" [class.active]="showTable" (click)="showTable = !showTable" i18n-title="@@Table View" title="Table View">
            <mat-icon>{{ showTable ? 'table_view' : 'view_module' }}</mat-icon><span class="toolbar-btn-label">{{ showTable ? 'Table' : 'Cards' }}</span>
          </button>
        </div>
        <button class="toolbar-filter-standalone" [class.active]="showCoverImage" (click)="showCoverImage = !showCoverImage" i18n-title="@@Cover Images" title="Cover Images">
          <mat-icon>{{ showCoverImage ? 'image' : 'hide_image' }}</mat-icon>
        </button>
        <button class="toolbar-filter-standalone" [class.active]="showDetails" (click)="showDetails = !showDetails" i18n-title="@@Details" title="Details">
          <mat-icon>{{ showDetails ? 'info' : 'info_outline' }}</mat-icon>
        </button>

        <div class="toolbar-divider"></div>

        <!-- Checkout action -->
        <div class="toolbar-actions">
          <button class="toolbar-action toolbar-action-primary" [disabled]="checkoutDisabled" (click)="proceedToCheckout()">
            <span class="toolbar-btn-label" i18n="@@Checkout">Checkout</span><mat-icon class="toolbar-icon-forward">arrow_forward</mat-icon>
          </button>
        </div>
      </div>

      <!-- Center: Checkout mode — back to cart -->
      <div class="app-toolbar-center" *ngIf="mode !== 'CART'">
        <div class="toolbar-actions">
          <button class="toolbar-action toolbar-action-secondary" (click)="backToCart()">
            <mat-icon class="toolbar-icon-back">arrow_back</mat-icon><span class="toolbar-btn-label" i18n="@@Back to Cart">Back to Cart</span>
          </button>
        </div>
      </div>

      <!-- End: Active Role -->
      <div class="app-toolbar-end">
        <app-active-role></app-active-role>
      </div>
    </div>
  </mat-toolbar>

  <mat-sidenav-container class="app-sidenav-container" (backdropClick)="mainSideNav.close()" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav opened #mainSideNav [mode]="mobileQuery.matches ? 'over' : 'side'" (keydown.escape)="mainSideNav.close()" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
      <mat-nav-list>
        <app-side-nav focus="cart"></app-side-nav>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="m2app-dark">
      <app-cart-page [narrow]="mobileQuery.matches"
                     [searchString]="searchString"
                     [showDetails]="showDetails"
                     [showCoverImage]="showCoverImage"
                     [showOnlyRecent]="showOnlyRecent"
                     [showNonZero]="showNonZero"
                     [showProducts]="showProducts"
                     [showDrafts]="showDrafts"
                     [showTable]="showTable"
                     [mode]="mode"
                     (modeChange)="mode = $event">
      </app-cart-page>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

